import { EntityType } from "@client/types";
import { isUndefined } from "lodash";

export const isReverseChildren = (value: boolean | undefined): boolean => value === true;
export const isStackChildren = (value: string | undefined): boolean => isUndefined(value) || value === "column";
export const isWrapChildren = (value: boolean | undefined): boolean => value === true;

export const getEntityClassName = (type: EntityType) => `_${type.toLowerCase().substring(0, 3)}`;
